import { useState, useEffect } from "react";
//@ts-ignore
import styles from "./CartDrawer.module.css";
import { CartConfigInterface, CartLineItem } from "../CartTypes";
import { ProductObj } from "../../Bundles/Types";

export default function ShippingProtectionCustomButton({
    cartConfig,
    standAlone,
    handleAdditionalProductAdd,
    cartLines,
    currentProduct,
    handleCheckout,
    customShippingProtection = false,
}: {
    handleAdditionalProductAdd: ({
        state,
        additionalProduct,
    }: {
        state: boolean;
        additionalProduct: ProductObj;
        checkoutWithShipping?: boolean;
    }) => Promise<void>;
    cartConfig: CartConfigInterface;
    customShippingProtection?: boolean;

    standAlone: boolean;
    currentProduct: ProductObj | null;

    cartLines: CartLineItem[];

    handleCheckout: (cartPage?: boolean) => void;
}) {
    const [show, setShow] = useState(false);

    useEffect(() => {
        setShow(!!customShippingProtection);
    }, [cartConfig, standAlone]);

    if (!show) return null;

    const handleClick = () => {
        if (standAlone) {
            if (currentProduct != null) {
                const lineIndex = cartLines?.findIndex(
                    (pd) => !!currentProduct?.id?.includes(pd.product_id as unknown as string),
                );

                if (lineIndex === -1) {
                    handleCheckout(cartConfig?.cart_settings?.redirect_to_checkout);
                    return;
                }

                handleAdditionalProductAdd({
                    state: false,
                    additionalProduct: {
                        ...currentProduct,
                        selectedVariants: [currentProduct?.variants[0]],
                    },
                    checkoutWithShipping: true,
                });
            }

            // handleCheckout(cartConfig?.cart_settings?.redirect_to_checkout);
        } else {
            handleCheckout(cartConfig?.cart_settings?.redirect_to_checkout);
        }
    };

    return (
        <div
            onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if (!standAlone) return;
                handleClick();
            }}
            style={{
                fontSize: cartConfig.cart_design?.footer_button_cta_text_size * 0.8,
                color: cartConfig?.cart_design?.footer_custom_shipping_button_color || "#c7a046",
                fontWeight: cartConfig?.cart_design?.footer_button_cta_text_style?.split(" ")[0],
                fontStyle: cartConfig?.cart_design?.footer_button_cta_text_style?.split(" ")[1],
                borderRadius: cartConfig?.cart_design?.footer_button_radius,
                // @ts-expect-error hack
                "--buttonHoverBg": cartConfig?.cart_design?.footer_button_bg_hover_color,
            }}
            className={`${styles.shippingProtectionButton}`}
        >
            {"Checkout without Shipping Protection >"}
        </div>
    );
}
